import { render, staticRenderFns } from "./TotalEditStyle.vue?vue&type=template&id=c9d79b66&scoped=true"
import script from "./TotalEditStyle.vue?vue&type=script&lang=ts"
export * from "./TotalEditStyle.vue?vue&type=script&lang=ts"
import style0 from "./TotalEditStyle.vue?vue&type=style&index=0&id=c9d79b66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d79b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d79b66')) {
      api.createRecord('c9d79b66', component.options)
    } else {
      api.reload('c9d79b66', component.options)
    }
    module.hot.accept("./TotalEditStyle.vue?vue&type=template&id=c9d79b66&scoped=true", function () {
      api.rerender('c9d79b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/TotalEditStyle.vue"
export default component.exports